<template>
  <div>
    <form>
      <div>LOGIN</div>
      <gl-input
        id="login.username"
        v-model.trim="form.username"
        v-skeletor:onChange="setValue"
        :type="'email'"
        :label="'Email'"
        :placeholder="'Email'"
        :value="form.username"
      >
      </gl-input>
      <gl-input
        id="login.password"
        v-model.trim="form.password"
        v-skeletor:onChange="setValue"
        :type="'password'"
        :label="'Password'"
        :placeholder="'Password'"
        :value="form.password"
      >
      </gl-input>
      <gl-button
        id="login.btn-login"
        color-primary
        :type="'submit'"
        :text="'Login'"
        :disabled="!dirtyFields"
        @onClick.prevent="login"
      ></gl-button>
      <p v-if="form.error">{{ form.error }}</p>
    </form>
  </div>
</template>

<script>
import { formatIds } from '../utils/functions.js';

export default {
  name: 'LoginPage',
  data() {
    return {
      form: {
        username: null,
        password: null,
        error: null
      },
      dirtyFields: false
    };
  },
  methods: {
    setValue(field, value, dirty) {
      this.setForm(formatIds(field), value, dirty);
      this.setDirtyField(dirty);
    },
    setForm(attr, value) {
      this.$set(this.form, attr, value);
    },
    setDirtyField(dirty) {
      this.dirtyFields = dirty;
    },
    async login() {
      try {
        await this.$store.dispatch('login', {
          username: this.form.username,
          password: this.form.password,
          sid: 'a0647baf-3ed5-484a-9240-4944dc7dbe5f'
        });
        await this.$store.dispatch('getPermissions');
        this.$router.push({ name: 'profile' });
      } catch (err) {
        // eslint-disable-next-line
        console.error(err);
        this.error = err;
      }
    }
  }
};
</script>

<style scoped>
p {
  padding: 30px;
  position: fixed;
  top: 25%;
  color: #bf616a;
}
form {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 2em;
}
gl-input {
  width: 350px;
  padding: 8px;
}
gl-button {
  margin-top: 20px;
}
</style>
